import { Body, Box, Heading, Stack, VStack } from '@hover/blueprint';
import { iconPlus } from '@hover/icons';
import React from 'react';
import { Trans } from 'react-i18next';

import ExteriorOne from 'src/assets/img/homeownerApp/projects/ideas/exterior-1.png';
import ExteriorTwo from 'src/assets/img/homeownerApp/projects/ideas/exterior-2.png';
import ExteriorThree from 'src/assets/img/homeownerApp/projects/ideas/exterior-3.png';
import ExteriorFour from 'src/assets/img/homeownerApp/projects/ideas/exterior-4.png';
import { LineBreak } from 'src/modules/designOrders/components';
import { ImageCarousel } from 'src/modules/homeownerApp/components/ImageCarousel';
import { PROJECT_DETAILS_PADDING } from 'src/modules/homeownerApp/components/Projects/Project/ProjectCardSection';
import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { HomeownerAppMenuNames } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { Button } from 'src/shared/components';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const EXTERIOR_IMAGES: Record<string, string> = {
  ExteriorOne,
  ExteriorTwo,
  ExteriorThree,
  ExteriorFour,
};

export const EmptyIdeas = () => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const { setCurrentMenu } = useHomeownerAppContext();
  const onAddPhotoClick = () => {
    setCurrentMenu(HomeownerAppMenuNames.UPLOAD_PHOTO);
  };

  return (
    <Stack
      backgroundColor="neutral.50"
      borderRadius={400}
      data-testid="empty-ideas"
      flexDirection={{ base: 'column', desktop: 'row' }}
      mx={PROJECT_DETAILS_PADDING}
      py={{ base: 600, tablet: 700, desktop: 900 }}
    >
      <ImageCarousel
        breakPointValues={{ base: '180px', tablet: '287px' }}
        images={EXTERIOR_IMAGES}
        pb={{ base: 600, tablet: 700, desktop: 900 }}
        px={{ base: 600, tablet: 700, desktop: 900 }}
      />
      <VStack
        alignItems="center"
        flex={{ desktop: 1 }}
        justifyContent="center"
        textAlign="center"
      >
        <Heading
          mb={{ base: 300, tablet: 400 }}
          textStyle={{
            base: 'heading500WithCapsize',
            tablet: 'heading600WithCapsize',
          }}
        >
          {t('projects.ideas.ideasForYou.title')}
        </Heading>
        <Body
          color="text.secondary"
          mt="0 !important"
          textStyle={{ base: 'bodySmall', tablet: 'bodyMedium' }}
        >
          <Trans
            components={{ LineBreak: <LineBreak /> }}
            i18nKey="projects.ideas.ideasForYou.subtitle"
            t={t}
          />
        </Body>
        <Box paddingTop={{ base: 500, desktop: 600 }}>
          <Button iconAfter={iconPlus} onClick={onAddPhotoClick} size="large">
            {t('projects.ideas.ideasForYou.cta')}
          </Button>
        </Box>
      </VStack>
    </Stack>
  );
};
